export default [
  'promo-heading-1',
  'promo-heading-2',
  'promo-heading-3',
  'promo-heading-4',
  'promo-heading-5',
]
